import React from 'react';

export default function AmazonBanner() {
  return (
    <section style={{
      background: 'linear-gradient(135deg, #232f3e 0%, #37475a 50%, #232f3e 100%)',
      padding: '36px 20px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Decoración de fondo */}
      <div style={{
        position: 'absolute', top: '-40px', right: '-40px',
        width: '180px', height: '180px', borderRadius: '50%',
        background: 'rgba(255,165,0,0.07)', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', bottom: '-30px', left: '10%',
        width: '120px', height: '120px', borderRadius: '50%',
        background: 'rgba(255,165,0,0.05)', pointerEvents: 'none',
      }} />

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '28px',
        flexWrap: 'wrap',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Lado izquierdo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          {/* Logo Amazon */}
          <div style={{
            background: 'white',
            borderRadius: '14px',
            padding: '10px 18px',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
          }}>
            <svg width="80" height="28" viewBox="0 0 80 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <text x="0" y="22" fontFamily="Arial Black, Arial" fontWeight="900" fontSize="22" fill="#232f3e">amazon</text>
            </svg>
          </div>

          <div>
            <div style={{
              fontSize: '11px',
              fontWeight: 800,
              letterSpacing: '1.5px',
              textTransform: 'uppercase',
              color: '#FF9900',
              marginBottom: '4px',
            }}>
              ✦ Recomendaciones
            </div>
            <h3 style={{
              color: 'white',
              fontWeight: 800,
              fontSize: 'clamp(1rem, 2.5vw, 1.35rem)',
              margin: 0,
              lineHeight: 1.25,
            }}>
              Encuentra lo mejor en Amazon
            </h3>
            <p style={{
              color: 'rgba(255,255,255,0.65)',
              fontSize: '13px',
              margin: '5px 0 0 0',
            }}>
              Productos con envío rápido a Chile · Millones de artículos
            </p>
          </div>
        </div>

        {/* Badges + Botón */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          {['📦 Envío rápido', '⭐ Top ventas', '🔒 Pago seguro'].map(badge => (
            <span key={badge} style={{
              background: 'rgba(255,255,255,0.10)',
              border: '1px solid rgba(255,255,255,0.18)',
              color: 'rgba(255,255,255,0.85)',
              fontSize: '12px',
              fontWeight: 700,
              padding: '6px 14px',
              borderRadius: '50px',
            }}>
              {badge}
            </span>
          ))}

          <a
            href="https://amzn.to/3S2wT2N"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: '#FF9900',
              color: '#111',
              fontWeight: 900,
              fontSize: '14px',
              padding: '13px 26px',
              borderRadius: '50px',
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(255,153,0,0.45)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              flexShrink: 0,
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'scale(1.06)';
              e.currentTarget.style.boxShadow = '0 6px 28px rgba(255,153,0,0.6)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(255,153,0,0.45)';
            }}
          >
            🛒 Ver en Amazon
          </a>
        </div>
      </div>
    </section>
  );
}
